import { createSlice } from "@reduxjs/toolkit";
import { getPendingRequestsThunk, getCheckinNotificationsThunk } from "../thunk";
import { logout } from "../slices";

const initialState = {
  items: [],
  loading: false,
  error: null,
  checkinItems: [],
  checkinLoading: false,
  checkinError: null,
};

const pendingRequestsSlice = createSlice({
  name: "pendingRequests",
  initialState,
  reducers: {
    clearPendingRequests: (state) => {
      state.items = [];
      state.error = null;
      state.checkinItems = [];
      state.checkinError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPendingRequestsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPendingRequestsThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.items = action.payload.data ?? [];
          state.error = null;
        } else {
          state.error =
            action.payload?.message || "Failed to fetch pending requests";
        }
      })
      .addCase(getPendingRequestsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch pending requests";
      })
      .addCase(getCheckinNotificationsThunk.pending, (state) => {
        state.checkinLoading = true;
        state.checkinError = null;
      })
      .addCase(getCheckinNotificationsThunk.fulfilled, (state, action) => {
        state.checkinLoading = false;
        if (action.payload?.success) {
          state.checkinItems = action.payload.data ?? [];
          state.checkinError = null;
        } else {
          state.checkinError =
            action.payload?.message || "Failed to fetch check-in notifications";
        }
      })
      .addCase(getCheckinNotificationsThunk.rejected, (state, action) => {
        state.checkinLoading = false;
        state.checkinError =
          action.payload?.message || "Failed to fetch check-in notifications";
      })
      .addCase(logout, () => initialState);
  },
});

export const { clearPendingRequests } = pendingRequestsSlice.actions;
export default pendingRequestsSlice.reducer;
